// KHỐI "ĐĂNG VIDEO" cho bản đồ giao diện (06/10/2026): một khối mỗi nền tảng (Facebook / YouTube / TikTok), thêm vào thư viện khối ở src/shared/khoi-thu-vien.ts
// (một dòng mỗi nền tảng) + phần hiển thị ở src/shared/ban-do.ts (HIEN_THI_VIDEO, NHAN_VIDEO).
//
// Khối chỉ có MỘT tham số `cau_hinh_video` (chữ "khoá=giá trị;…" — xem video-dang.ts). Trang Kịch bản dựng ô riêng cho tham số này (nút bấm, mục "Nâng cao" thu
// gọn, dòng tóm tắt); AI lập kịch bản KHÔNG điền tham số này (người dùng chọn trên trang) — mô tả khối ghi rõ.
//
// Phần thực thi KHÔNG phải danh sách thao tác selector như khối khác: bước mang khoá `dang_video` (nen_tang + cau_hinh) và plugin chạy động cơ riêng
// (src/background/dang-video/chay.ts). Bundle có khoá này tự khai can_plugin = PLUGIN_CAN_DANG_VIDEO.
import type { KhoiMau } from "./tu-dung";
import { macDinhThamSoVideo, TEN_THAM_SO_VIDEO } from "./video-dang";
import { TEN_NEN_TANG_VIDEO, type NenTangVideo } from "./video-kho";

export const ID_BUOC_DANG_VIDEO = "dang_video";
export const MA_THAO_TAC_DANG_VIDEO = "dang_video";

function khoi(nt: NenTangVideo): KhoiMau {
  const ten = TEN_NEN_TANG_VIDEO[nt];
  return {
    ten: MA_THAO_TAC_DANG_VIDEO,
    moTa: `Đăng MỘT video lấy từ KHO VIDEO của chủ bot lên ${ten}${nt === "facebook" ? " (Tường cá nhân; video ngắn dọc đăng dạng Reel)" : nt === "youtube" ? " (kênh; video ngắn dọc ≤ 60 giây là Shorts)" : " (tài khoản)"}: máy chủ cấp video chưa đăng của bot (mỗi video chỉ đăng MỘT lần cho mỗi bot), tải về, điền tiêu đề / mô tả / hashtag của video, chọn riêng tư hoặc công khai, chờ xử lý xong rồi bấm Đăng và đọc lại để xác nhận. Hết video thì kết thúc "Hết video chưa đăng" (không đăng lại). Rủi ro cao. Tham số cau_hinh_video do người dùng chọn trên trang bằng các nút — AI KHÔNG tự điền.`,
    thamSo: [
      { ten: TEN_THAM_SO_VIDEO, moTa: "cách chọn video, kiểu đăng, riêng tư/công khai, trần mỗi ngày… (người dùng chọn trên trang; AI không điền)", kieu: "chuoi", batBuoc: false, macDinh: macDinhThamSoVideo(nt), anKhiRong: true },
    ],
    params: { [TEN_THAM_SO_VIDEO]: { type: "string", default: `{{ts.${TEN_THAM_SO_VIDEO}}}`, label: "Cách đăng video" } },
    yamlSteps: `  - id: ${ID_BUOC_DANG_VIDEO}
    on: web
    do: "đăng một video lấy từ Kho video lên ${ten}"
    risk: high
    idempotent: unsafe
    retry: 0
    timeout: 3600s`,
    learned: { [ID_BUOC_DANG_VIDEO]: { dang_video: { nen_tang: nt, cau_hinh: `{{ts.${TEN_THAM_SO_VIDEO}}}` } } },
    trangThu: "CHƯA kiểm trên trang thật (06/10/2026): bộ chọn viết theo cấu trúc đã biết, xem src/shared/video-nen-tang.ts",
  };
}

export const KHOI_DANG_VIDEO: Readonly<Record<NenTangVideo, KhoiMau>> = { facebook: khoi("facebook"), youtube: khoi("youtube"), tiktok: khoi("tiktok") };

/** Hiển thị trong bản đồ: khoá "<mạng>/<thao tác>" như HIEN_THI của ban-do.ts. mauMoTa chứa dấu hiệu {@video:<mạng>} → moTaThaoTac thay bằng dòng tóm tắt. */
export const HIEN_THI_VIDEO: Readonly<Record<string, { bieuTuong: string; tenNgan: string; mauMoTa: string }>> = {
  "facebook/dang_video": { bieuTuong: "🎬", tenNgan: "Đăng video lên Facebook", mauMoTa: "{@video:facebook}" },
  "youtube/dang_video": { bieuTuong: "🎬", tenNgan: "Đăng video lên YouTube", mauMoTa: "{@video:youtube}" },
  "tiktok/dang_video": { bieuTuong: "🎬", tenNgan: "Đăng video lên TikTok", mauMoTa: "{@video:tiktok}" },
};
export const NHAN_VIDEO: Readonly<Record<string, string>> = { [TEN_THAM_SO_VIDEO]: "Cách đăng video" };
